import { TILE_CLASSES } from '../constants/classNames';
import { joinClassNames } from '../utils/classNameUtils';
import '../styles/SubstanceTile.css';

export default function SubstanceTile({
  substance,
  isSelected,
  isDimmed = false,
  isSearchMatch = false,
  gridPosition = null,
  onSelect,
}) {
  const positionStyle = gridPosition ? { gridRow: gridPosition.row, gridColumn: gridPosition.column } : undefined;

  return (
    <button
      type="button"
      style={positionStyle}
      className={joinClassNames(
        TILE_CLASSES.root,
        `${TILE_CLASSES.categoryPrefix}${substance.category}`,
        isSelected && TILE_CLASSES.selected,
        isDimmed && TILE_CLASSES.dimmed,
        isSearchMatch && TILE_CLASSES.searchMatch
      )}
      data-substance-id={substance.id}
      aria-pressed={isSelected}
      aria-label={substance.getDisplayLabel()}
      title={`${substance.getDisplayLabel()}: ${substance.description}`}
      onClick={() => onSelect(substance.id)}
    >
      {substance.isElement() && <span className={TILE_CLASSES.number}>{substance.atomicNumber}</span>}
      <span className={TILE_CLASSES.symbol}>{substance.symbol}</span>
      <span className={TILE_CLASSES.name}>{substance.name}</span>
    </button>
  );
}
